import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SwitchBox } from '../../molecules/switch-box';
import { ValueBox } from '../../molecules/value-box';
import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { SimpleTable } from '../../molecules/simple-table';
import { useSelector } from '../../store/utils';
import { trpc } from '../../api/trpc';

const MqttBroker = () => {
  const [serviceActive, running] = useSelector(
    ({ variables }) =>
      [variables.SERVICE_ACTIVE, variables.MQTT_BROKER_RUNNING] as const
  );

  const { data } = trpc.listMqttBrokerClients.useQuery(undefined, {
    refetchInterval: 1_000,
  });

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="mqtt_broker.title"
            defaultMessage="MQTT Broker"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="mqtt_broker.title"
            defaultMessage="MQTT Broker"
          />
        }
      >
        <SwitchBox
          switchVariableId="MQTT_BROKER_ENABLED"
          title={
            <FormattedMessage
              id="mqtt_broker.enabled"
              defaultMessage="Zapnuto"
            />
          }
          fullWidth
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage id="mqtt_broker.running" defaultMessage="Stav" />
          }
          value={running ? 'Aktivní' : 'Neaktivní'}
        />

        <SimpleTable
          title={
            <FormattedMessage
              id="mqtt_broker.connected_clients.title"
              defaultMessage="Clients"
            />
          }
          rows={[['ID', ''], ...(data || []).map(({ id }) => [id, ''])]}
        />
      </Group>
    </>
  );
};

export default MqttBroker;
